export const BLACK_PIECE = "BLACK_PIECE";
export const BLACK_PIECE_HIGHLIGHTED = "BLACK_PIECE_HIGHLIGHTED";
export const RED_PIECE = "RED_PIECE";
export const RED_PIECE_HIGHLIGHTED = "RED_PIECE_HIGHLIGHTED";
export const BLACK_TO_PLAY = "BLACK_TO_PLAY";
export const BLACK_CHOSE_PIECE = "BLACK_CHOSE_PIECE";
export const RED_TO_PLAY = "RED_TO_PLAY";
export const RED_CHOSE_PIECE = "RED_CHOSE_PIECE";
